import { render, staticRenderFns } from "./OrderCheckMessage.vue?vue&type=template&id=c49d7b4c&scoped=true"
import script from "./OrderCheckMessage.vue?vue&type=script&lang=ts"
export * from "./OrderCheckMessage.vue?vue&type=script&lang=ts"
import style0 from "./OrderCheckMessage.vue?vue&type=style&index=0&id=c49d7b4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49d7b4c",
  null
  
)

export default component.exports